import React, { useContext, useMemo } from "react";
import { hasValue } from "../../helper";
import { LocalizationContext } from "../localization";

export type LocalizationScopeItem = string | null;

export interface LocalizationScopeProps {
  children: React.ReactNode;
  scope?: LocalizationScopeItem | LocalizationScopeItem[];
  drop?: number;
}

export const LocalizationScope = ({
  children,
  scope = [],
  drop = 0,
}: LocalizationScopeProps) => {
  const context = useContext(LocalizationContext);

  const value = useMemo(() => {
    if (!context) return null;
    let finalScope = [scope].flat(Infinity).filter((x) => hasValue(x));
    return {
      ...context,
      scopes: [
        ...(finalScope.length > 0 ? [finalScope] : []),
        ...context.scopes.slice(drop),
      ],
    };
  }, [context, scope, drop]);

  return (
    <LocalizationContext.Provider value={value}>
      {children}
    </LocalizationContext.Provider>
  );
};
